function PostnatalCare() {
    return (
      <div className="container my-5">
        <h2 className="text-center mb-4">Postnatal Care Package (First 6 Days)</h2>
        
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card h-100">
              <div className="card-header bg-success text-white">
                <h4>Mother's Care</h4>
              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Vital signs monitoring</li>
                  <li className="list-group-item">Uterine involution checks</li>
                  <li className="list-group-item">Postpartum depression screening</li>
                  <li className="list-group-item">Breastfeeding support</li>
                </ul>
              </div>
            </div>
          </div>
  
          <div className="col-md-6">
            <div className="card h-100">
              <div className="card-header bg-success text-white">
                <h4>Newborn Care</h4>
              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Weight & growth tracking</li>
                  <li className="list-group-item">Feeding pattern assessment</li>
                  <li className="list-group-item">Cord care education</li>
                  <li className="list-group-item">Vaccination schedule</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
  
        <div className="mt-4 alert alert-info">
          <h4>Follow-up Protocol</h4>
          <p>Daily home visits for first 3 days, then alternate-day visits</p>
        </div>
      </div>
    );
  }

  export default PostnatalCare;